/* eslint-disable no-console */
var warnings;
if (process.env.NODE_ENV === 'development') {
    warnings = new Set();
}
function devWarning(message) {
    if (!(process.env.NODE_ENV === 'development') || (warnings === null || warnings === void 0 ? void 0 : warnings.has(message)))
        return;
    console.warn(message);
}

export { devWarning };
